import { render, staticRenderFns } from "./BuilderSidebarSettings.vue?vue&type=template&id=2547895e&scoped=true&"
import script from "./BuilderSidebarSettings.vue?vue&type=script&lang=js&"
export * from "./BuilderSidebarSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547895e",
  null
  
)

export default component.exports